import { CreateWorkTaskDto } from "@/core/features/tasks/embed-dtos/create-work-task.dto";

export class UpdateWorkTaskDto extends CreateWorkTaskDto {}
